module.exports = __webpack_public_path__ + "img/100.9709ff46.svg";